import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AnimationsConfig } from '@qaroni-core/config/app/animations.config';

@Component({
  selector: 'qaroni-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingComponent {
  readonly height = input<number>(400);

  public src: string;

  constructor() {
    this.src = AnimationsConfig.bouncingBallLoader;
  }
}
